var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('owal-modal',{attrs:{"show":_vm.show}},[_c('div',{staticClass:"owal logo spinner container",attrs:{"slot":"content"},slot:"content"},[_c('owal-spinner-logo',{staticClass:"owal logo spinner content"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }